import {
  Button,
  constants,
  FloppyHollowSVG,
  useWindowSize,
} from "@newsela/angelou";
import {
  actionNames,
  actionPrefixes,
  objectTypes,
  withTrackEvent,
} from "@newsela/snitch";

import { Assignment } from "@/types/models/Assignment.interface";
import {
  ASSIGNMENT_MODE,
  currentAssignmentMode,
} from "@/view/utils/currentAssignmentMode";
import { TAssignmentMode } from "@/view/utils/currentAssignmentMode/currentAssignmentMode";
import {
  draftButtonCss,
  footerLayoutCss,
  primaryBtnCss,
  secondaryBtnsCss,
} from "./Footer.style";
import FooterActionButton from "./FooterActionButton";

const ButtonWithTrackEvent = withTrackEvent(
  Button,
) as React.ForwardRefExoticComponent<
  React.ComponentProps<typeof Button> & React.RefAttributes<HTMLButtonElement>
>;

type onClick = () => void;

export const Footer = (props: {
  onClickCancel: onClick;
  onClickCreate: onClick;
  onClickSaveChanges: onClick;
  onClickSaveDraft: onClick;
  updatedAssignment: Assignment;
}) => {
  const {
    onClickCancel,
    onClickCreate,
    onClickSaveChanges,
    onClickSaveDraft,
    updatedAssignment,
  } = props;
  const { width: windowWidth } = useWindowSize();
  const {
    breakpoints: {
      Breakpoints: { sm },
    },
  } = constants;
  const isMobile = windowWidth <= sm;

  const assignmentMode = currentAssignmentMode(updatedAssignment);

  const isCreateMode = assignmentMode === ASSIGNMENT_MODE.CREATE;

  const CancelButton = (props: { onClick: onClick }) => (
    <ButtonWithTrackEvent
      flavor={
        isCreateMode && isMobile
          ? Button.flavors.tertiary
          : Button.flavors.secondary
      }
      onClick={
        props.onClick
      } /* @ts-expect-error TODO: remove when withTrackEvent is typed */
      objectType={objectTypes.assignment}
      actionPrefix={actionPrefixes.initiate}
      actionName={actionNames.cancel}
      dataProps={{
        "data-qa-selector": "cancel-assignment-modal",
      }}
    >
      Cancel
    </ButtonWithTrackEvent>
  );

  return (
    <div css={footerLayoutCss(isCreateMode)}>
      <div css={secondaryBtnsCss(isCreateMode)}>
        <CancelButton onClick={onClickCancel} />
        {isCreateMode ? (
          <FooterActionButton
            dataProps={{
              "data-qa-selector": "create-draft-assignment-in-assignment-modal",
            }}
            flavor={Button.flavors.secondary}
            label="Save draft"
            onClick={onClickSaveDraft}
            icon={{
              SvgComponent: FloppyHollowSVG,
              alignment: Button.iconAlignments.left,
            }}
            __cssFor={{ root: draftButtonCss }}
          />
        ) : (
          <></>
        )}
      </div>
      <div css={primaryBtnCss}>
        {isCreateMode ? (
          <FooterActionButton
            assignmentMode={ASSIGNMENT_MODE.CREATE as TAssignmentMode}
            onClick={onClickCreate}
          />
        ) : (
          <FooterActionButton
            assignmentMode={ASSIGNMENT_MODE.UPDATE as TAssignmentMode}
            onClick={onClickSaveChanges}
          />
        )}
      </div>
    </div>
  );
};

export default Footer;
